import BaseStore from 'stores/base'

export default class SalesInvoiceStore extends BaseStore {
  constructor(service, options) {
    super(service)
    this.service = service
  }
}
